<template>
  <div class="generated-items-list">
    <figure
      class="figure generated-item"
      v-for="(item, uuid) in generatedItems"
      :key="uuid"
      :title="item.name"
    >
      <figcaption class="figure-caption text-truncate">
        <small>{{ item.name }}</small>
      </figcaption>
      <div class="figure-image">
        <img
          class="img-fluid rounded"
          :src="item.image.url"
          :alt="item.image.name"
        />
        <div class="figure-controls">
          <a class="text-dark mb-1" @click="download(item.image)">
            <small><i class="fa fa-cloud-download"></i> Baixar</small>
          </a>
          <a class="text-dark mb-1" @click="editGeneratedItem(uuid)">
            <small><i class="fa fa-edit"></i> Modificar</small>
          </a>
          <a class="text-dark" @click="removeGeneratedItem(uuid)">
            <small><i class="fa fa-trash"></i> Destruir</small>
          </a>
        </div>
      </div>
    </figure>
  </div>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';

  export default {
    name: 'GeneratedItemsList',
    props: {
      generatedItems: Object
    },
    computed: {
      hasGeneratedItems () {
        return !!Object.keys(this.generatedItems).length;
      }
    },
    methods: {
      ...mapActions([ 'editGeneratedItem' ]),
      ...mapMutations({
        removeGeneratedItem: 'REMOVE_GENERATED_ITEM',
      }),
      download (image) {
        const a = document.createElement('a');
        a.href = image.url.replace('image/jpeg', 'image/octet-stream');
        a.download = image.name;
        a.click();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .generated-items-list {
    // height: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    @mixin scroll-shadow {
      -webkit-box-shadow: inset 0 0 .1rem #AAA;
      -moz-box-shadow: inset 0 0 .1rem #AAA;
      box-shadow: inset 0 0 .1rem #AAA;
    }

    &::-webkit-scrollbar-track {
      @include scroll-shadow;
      background-color: #F5F5F5;
      border-radius: .5rem;
    }

    &::-webkit-scrollbar {
      height: .5rem;
      background-color: #F5F5F5;
      border-radius: .5rem;
    }

    &::-webkit-scrollbar-thumb {
      @include scroll-shadow;
      background-color: #aaa;
      border-radius: .5rem;

    }

    .generated-item {
      cursor: pointer;
      display: inline-block;
      margin: .25rem 0 .5rem 0;
      width: 9rem;

      + .generated-item {
        margin-left: 1rem;
      }

      .figure-image {
        position: relative;

        .figure-controls {
          background: rgba(#fff, .8);
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: center;
          left: 0;
          opacity: 0;
          padding-left: 2rem;
          position: absolute;
          top: 0;
          transition: opacity .25s;
          width: 100%;
        }

        &:hover .figure-controls {
          opacity: 1;
        }
      }
    }
  }
</style>